import PortalLayout from '../../shared/components/PortalLayout';
import RoleSummaryTab from './RoleSummaryTab';
import ErrorBoundary from './ErrorBoundary';

/**
 * ⚠⚠ V65 — EL ErrorBoundary VA ACÁ, EN LA RUTA, y no solo adentro de una pestaña.
 *
 * Se agregó en V65 para que un componente roto degradara en vez de tumbar la pantalla, y
 * la PRIMERA vez que hizo falta no sirvió: se había envuelto la pestaña de Vacaciones y
 * las tres de /admin, pero `/dashboard` renderizaba RoleSummaryTab desnudo. Un
 * `ReferenceError` en la pestaña de Gastos —un import que faltaba— dejó el dashboard en
 * blanco para TODOS los usuarios, exactamente el fallo que la frontera existía para
 * evitar.
 *
 * La lección: una frontera protege lo que está ADENTRO. Ponerla en el hijo de moda y no
 * en la raíz de la ruta deja descubierto todo lo demás, y encima da la sensación de que
 * el problema está cubierto.
 */
export default function DashboardPage() {
  return (
    <PortalLayout activeModule="dashboard">
      <ErrorBoundary seccion="Dashboard">
        <RoleSummaryTab />
      </ErrorBoundary>
    </PortalLayout>
  );
}
